__turbopack_context__.v({
  "authorText": "table-of-contents-links-module-scss-module__Zt2MDG__authorText",
  "links": "table-of-contents-links-module-scss-module__Zt2MDG__links",
  "list": "table-of-contents-links-module-scss-module__Zt2MDG__list",
  "listItem": "table-of-contents-links-module-scss-module__Zt2MDG__listItem",
  "title": "table-of-contents-links-module-scss-module__Zt2MDG__title",
  "titleBox": "table-of-contents-links-module-scss-module__Zt2MDG__titleBox",
});
